import AddImageModalContainer from 'components/AddImageModal/AddImageModalContainer'

export default {
  Container: AddImageModalContainer,
}
